import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  CustomDropdown,
  CustomPanel,
  ImportExcelFile,
  PageHeader,
} from '../../../../components'
import { hideLoadingBox, showMessageBox } from '../../../../store/actions/system.actions'
import useImportarApuracao, { ARQUIVO_FORMATOS, LOAD_MESSAGE } from './ImportarApuracaoHook'

function ImportarApuracao({ dispatch, selectedTp, data, history }) {
  const { state, localDispatch } = useImportarApuracao()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.UPLOAD_APURACAO:
        dispatch(hideLoadingBox())
        localDispatch.uploadImportacaoApuracao(selectedTp, state.fileContent, state.selectedFormato)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage.replace('$QTE', state.itensApurados)))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <PageHeader>3.8 - RETORNO DO VEÍCULO DE ENTREGA PARA ROTA - Importar Apuração</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onVoltar={history.goBack} showBtnNovo={false}>
          <div className="p-grid">
            <div className="p-col-3 p-col-align-center" style={{ paddingTop: 0 }}>
              <CustomDropdown
                label="Tipo de Arquivo"
                onChange={localDispatch.onFormatoArquivoChange}
                options={ARQUIVO_FORMATOS}
                optionLabel="name"
                value={state.selectedFormato}
              />
            </div>
            <div className="p-col-3 p-col-align-center" style={{ paddingTop: 15 }}>
              <Btn
                onClick={() => localDispatch.onBtnExportarExcel(state.selectedFormato, selectedTp)}
              >
                <i className="pi pi-download"></i> Exportar Modelo
              </Btn>
              <ImportExcelFile
                label="Importar"
                classes="btnImportar"
                hasIcon={true}
                onFileImported={content =>
                  localDispatch.onBtnImportarClick(content, state.selectedFormato, selectedTp)
                }
              />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

const mapToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapToProps)(withRouter(ImportarApuracao))
